module.exports = __webpack_public_path__ + "img/SpfRecord.cc205d83.jpg";